// extracted by mini-css-extract-plugin
export default {"consentLabel":"ConsentLabel_consentLabel__OKASC","consentLabelSubTitle":"ConsentLabel_consentLabelSubTitle__6Gtk4"};